import type { IconNode } from '../types';

/**
 * @name door-closed-cog
 * @description Lucide SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJtMTQuMzA1IDE5LjUzLjkyMy0uMzgyIiAvPgogIDxwYXRoIGQ9Im0xNS4yMjkgMTYuODUyLS45MjQtLjM4MyIgLz4KICA8cGF0aCBkPSJtMTYuODUyIDE1LjIyOC0uMzgzLS45MjMiIC8+CiAgPHBhdGggZD0ibTE2Ljg1MiAyMC43NzMtLjM4My45MjQiIC8+CiAgPHBhdGggZD0iTTE5IDEwLjM1VjVhMiAyIDAgMDAtMi0ySDdhMiAyIDAgMDAtMiAydjE2IiAvPgogIDxwYXRoIGQ9Im0xOS4xNDggMTUuMjI4LjM4My0uOTIzIiAvPgogIDxwYXRoIGQ9Im0xOS41MyAyMS42OTctLjM4Mi0uOTI0IiAvPgogIDxwYXRoIGQ9Ik0yIDIxaDguNTgiIC8+CiAgPHBhdGggZD0ibTIwLjc3MyAxNi44NTIuOTIyLS4zODMiIC8+CiAgPHBhdGggZD0ibTIwLjc3MyAxOS4xNDguOTIyLjM4MyIgLz4KICA8cGF0aCBkPSJNOSAxMmguMDEiIC8+CiAgPGNpcmNsZSBjeD0iMTgiIGN5PSIxOCIgcj0iMyIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/door-closed-cog
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const DoorClosedCog: IconNode = [
  ['path', { d: 'm14.305 19.53.923-.382' }],
  ['path', { d: 'm15.229 16.852-.924-.383' }],
  ['path', { d: 'm16.852 15.228-.383-.923' }],
  ['path', { d: 'm16.852 20.773-.383.924' }],
  ['path', { d: 'M19 10.35V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16' }],
  ['path', { d: 'm19.148 15.228.383-.923' }],
  ['path', { d: 'm19.53 21.697-.382-.924' }],
  ['path', { d: 'M2 21h8.58' }],
  ['path', { d: 'm20.773 16.852.922-.383' }],
  ['path', { d: 'm20.773 19.148.922.383' }],
  ['path', { d: 'M9 12h.01' }],
  ['circle', { cx: '18', cy: '18', r: '3' }],
];

export default DoorClosedCog;
